<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="6" xl="8" class="pr-sm-5 pr-0">
        <BaseFormAutocomplete
          id-element="filterPolicy"
          placeholder="Tomador Matriz/Filial ou CNPJ"
          v-model="legacyFilter.grupo_economico_id"
          :items="currentAutoCompleteFilter"
          hide-no-data
          item-text="nome"
          item-value="id"
          template-taker
          validate-on-blur
          @keyup="searchInput"
          :return-object="true"
          :rules="[requiredValidTaker]"
          label-text="Grupo Econômico"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="pr-sm-5">
        <p class="primary--text font-weight-bold body-2 mb-3">
          Período - De
        </p>
        <BaseFilter
          v-model="legacyFilter.periodo_de"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid]"
          validate-on-blur
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2">
        <p class="primary--text font-weight-bold body-2 mb-3">
          Período - Até
        </p>
        <BaseFilter
          v-model="legacyFilter.periodo_ate"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid]"
          validate-on-blur
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseFormSelect
          id-element="typeFileLegacyImportation"
          placeholder="Selecionar"
          v-model="legacyFilter.tipo_arquivo"
          label-text="Tipo de Importação"
          :items="itemsTypeLegacyImportation"
          item-text="nome"
          item-value="id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseFormSelect
          id-element="StatusLegacyImportation"
          placeholder="Selecionar"
          v-model="legacyFilter.status"
          label-text="Status"
          :items="itemsStatusLegacyImportation"
          item-text="nome"
          item-value="id"
        />
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="2" class="pr-0 pb-5 pb-md-0 pr-sm-3 pt-md-8">
        <BaseButton
          v-html="'PESQUISAR'"
          class="secondary white--text"
          width="100%"
          @click="searchWithFilters"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pb-5 pb-md-0 pt-md-8">
        <BaseButton
          v-html="'LIMPAR'"
          color="secondary"
          width="100%"
          outlined
          @click="resetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="auto">
        <p class="primary--text">
          {{ timeUpdated }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="itemsLegacyImportation.items"
          no-data-text="Nenhuma Importação foi encontrada"
          loading-text="Carregando Importações..."
          :options.sync="options"
          :server-items-length="itemsLegacyImportation.total_count"
        >
          <template v-slot:[`item.data_solicitacao`]="{ item }">
            {{ formatHistoricDate(item.data_solicitacao) }}
          </template>
          <template v-slot:[`item.importado_por`]="{ item }">
            {{ item.importado_por.nome }}
          </template>
          <template v-slot:[`item.grupo_economico`]="{ item }">
            {{ item.grupo_economico.nome }}
          </template>
          <template v-slot:[`item.tipo_arquivo`]="{ item }">
            {{ item.tipo_arquivo.name }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            {{ item.status.name }}
          </template>
          <template v-slot:[`item.opcoes`]="{ item }">
            <v-tooltip bottom content-class="tooltip-label-form">
              <template v-slot:activator="{ on }">
                <BaseButton
                  color="secondary"
                  class="px-0 mr-2 mb-2"
                  @click.stop="onPreviewFile(item.arquivo)"
                  v-on="on"
                >
                  <v-icon color="white">
                    fa-file
                  </v-icon>
                </BaseButton>
              </template>
              <div class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Faça download do arquivo de importação
                </p>
              </div>
            </v-tooltip>
            <v-tooltip
              bottom
              content-class="tooltip-label-form"
              v-if="item.pode_cancelar"
            >
              <template v-slot:activator="{ on }">
                <BaseButton
                  color="pink"
                  class="px-0 mb-2"
                  v-on="on"
                  @click="openModalCancel(item.id)"
                >
                  <v-icon color="white">
                    fa-times-circle
                  </v-icon>
                </BaseButton>
              </template>
              <div class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Cancelar a solicitação de importação
                </p>
              </div>
            </v-tooltip>
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
    <ModalGenericCriticism
      v-model="modal"
      @close="closeModal"
      title="CANCELAR IMPORTAÇÃO"
      :text="text"
      has-cancel-button
      text-button="SIM"
    />
  </v-form>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import {
  formatHistoricDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import _ from "lodash";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
const MOCK_FILTER = {
  grupo_economico_id: null,
  periodo_de: null,
  periodo_ate: null,
  tipo_arquivo: null,
  status: null
};
const tableHeaders = [
  { text: "N° da Importação", value: "numero_protocolo", sortable: true },
  {
    text: "Data e Hora",
    value: "data_solicitacao",
    sortable: true
  },
  {
    text: "Usuário",
    value: "importado_por",
    sortable: true
  },
  {
    text: "Grupo Econômico",
    value: "grupo_economico",
    sortable: true
  },
  { text: "Tipo da Importação", value: "tipo_arquivo", sortable: true },
  { text: "Status", value: "status", sortable: true },
  { text: "Opções", value: "opcoes", sortable: false }
];
const MOCK_OPTIONS = {
  groupBy: [],
  groupDesc: [],
  itemsPerPage: 5,
  multiSort: false,
  mustSort: false,
  page: 1,
  sortBy: [],
  sortDesc: []
};
export default {
  mixins: [LoadingRequest, DocumentsMixin],
  data: function() {
    return {
      currentAutoCompleteFilter: [],
      tableHeaders,
      legacyFilter: {},
      dateTermValid,
      maskDate,
      options: MOCK_OPTIONS,
      formatHistoricDate,
      idCancel: null,
      modal: false,
      text: null,
      formatDDMMYYYYToIsoDate,
      lastUpdate: new Date(),
      debounceFetch: _.debounce(this.searchWithFilters, 120000)
    };
  },
  components: {
    ModalGenericCriticism
  },
  created() {
    if (this.numberLegacy) {
      this.updateFilterLegacy();
    }
    this.searchWithFilters();
  },
  beforeDestroy() {
    this.debounceFetch.cancel();
  },
  watch: {
    options: {
      handler() {
        this.searchWithFilters();
      },
      deep: true
    },
    numberLegacy(value) {
      if (value) {
        this.updateFilterLegacy();
      }
    },
    async currentTab(value) {
      if (value === 0) {
        this.debounceFetch.cancel();
      } else {
        this.searchWithFilters();
      }
    }
  },
  computed: {
    ...mapState("legacy_importation", [
      "itemsLegacyImportation",
      "itemsStatusLegacyImportation",
      "itemsTypeLegacyImportation"
    ]),
    requiredValidTaker() {
      return (
        this.validateFilterTaker() ||
        "É preciso selecionar um grupo econômico válido"
      );
    },
    timeUpdated() {
      return `Status atualizado em ${formatHistoricDate(
        this.lastUpdate.toISOString()
      )}`;
    }
  },
  methods: {
    ...mapActions("legacy_importation", [
      "requestItemsLegacyImportation",
      "requestCancelLegacyImportation",
      "requestAutoCompleteEconomicGroup"
    ]),
    ...mapActions(["showAlertNotification"]),
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          vm.fetchAutocompleteFilter(value.target.value);
          vm.timeout = null;
        }, 500);
    },
    validateFilterTaker() {
      return !this.legacyFilter.filter || Boolean(this.legacyFilter.filter?.id);
    },
    fetchAutocompleteFilter(value) {
      const payload = { query: value };
      this.withLoading(
        this.requestAutoCompleteEconomicGroup(payload).then(data => {
          this.currentAutoCompleteFilter = data;
        })
      );
    },
    searchWithFilters() {
      this.fetchLegacyImportation(this.getPayload());
    },
    resetFilter() {
      this.options = _.cloneDeep(MOCK_OPTIONS);
      this.legacyFilter = _.cloneDeep(MOCK_FILTER);
      this.fetchLegacyImportation(this.getPayload());
    },
    fetchLegacyImportation(payload) {
      this.lastUpdate = new Date();
      this.withLoading(
        this.requestItemsLegacyImportation(payload).then(() => {
          this.debounceFetch();
        })
      );
    },
    getPayload() {
      let payload = _.cloneDeep(this.legacyFilter);
      if (payload.grupo_economico_id?.id) {
        payload.grupo_economico_id = payload.grupo_economico_id.id;
      } else {
        payload.grupo_economico_id = null;
      }
      if (payload.periodo_de)
        payload.periodo_de = this.formatDDMMYYYYToIsoDate(payload.periodo_de);
      if (payload.periodo_ate)
        payload.periodo_ate = this.formatDDMMYYYYToIsoDate(payload.periodo_ate);
      const { page, itemsPerPage, sortDesc, sortBy } = this.options;
      const directSort =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      // Pegar do headers o elemento que será ordenado
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      payload.page = page;
      payload.page_size = itemsPerPage;
      payload.sort = sort;
      payload.direction = directSort;
      return payload;
    },
    cancelLegacyImportation() {
      this.withLoading(
        this.requestCancelLegacyImportation(this.idCancel).then(() => {
          this.showAlertNotification({
            message: "Importação cancelada com sucesso.",
            type: "success"
          });
          this.fetchLegacyImportation(this.getPayload());
        })
      );
    },
    openModalCancel(id) {
      this.modal = true;
      this.text = `Tem certeza de que deseja cancelar a solicitação de importação ${id}?`;
      this.idCancel = id;
    },
    closeModal(value) {
      this.modal = false;
      if (value) {
        this.cancelLegacyImportation();
      }
    },
    updateFilterLegacy() {
      // mantendo esse método p/ eventualmente filtrar pela importação requisitada
    }
  },
  props: {
    currentTab: {
      type: Number
    },
    numberLegacy: {
      type: String
    }
  }
};
</script>
